import "./base/Function";
import "./base/Array";
import "./base/Date";
import "./base/String";
import '../lib/prism';
import Control3D from '../lib/CSS3D.js';
// import '../lib/three';
import Event from "@/event";

import '../styles/antd.less';
import '../styles/variables.less';
import '../styles/layout.less';
import '../styles/state.less';
import '../styles/theme.less';
import '../styles/transition.less';
import '../styles/response.less';
import '../lib/CSS3D.css';
import '../lib/markdown.css';
import '../lib/prism.css';
import '../lib/cube.css';
import 'braft-editor/dist/index.css'

window._event = new Event();
window.Control3D = Control3D;